import { intranetFileDownloadPath } from '@gb-ticket/shared-types';

import { API_BASE_URL } from '@/lib/api';

export function fileDownloadHref(fileId: string): string {
  return `${API_BASE_URL}${intranetFileDownloadPath(fileId)}`;
}

/** Short label for a file: extension in capitals (`PDF`, `DOCX`), else „Datei“. */
export function fileTypeLabel(file: { filename: string }): string {
  const dot = file.filename.lastIndexOf('.');
  const extension = dot > 0 ? file.filename.slice(dot + 1) : '';
  return /^[a-z0-9]{1,5}$/i.test(extension) ? extension.toUpperCase() : 'Datei';
}
